// Empty / unset → same-origin relative URLs (recommended behind nginx on GCP).
// Do not bake a raw IP here — that causes cross-origin + CORS (e.g. chat) when
// users open the site via hostname.
const rawApi = process.env.REACT_APP_API_BASE_URL;
const rawDevice = process.env.REACT_APP_DEVICE_API_BASE_URL;
export const API_BASE_URL =
  !rawApi || rawApi === "undefined" ? "" : rawApi.replace(/\/$/, "");
export const DEVICE_API_BASE_URL =
  !rawDevice || rawDevice === "undefined" ? API_BASE_URL : rawDevice.replace(/\/$/, "");

export const ENDPOINTS = {
  LIVE_FEEDS: `${API_BASE_URL}/command-center/cc-alerts/live-feeds/`,
  CAMERA_DETAILS: (cameraId) => `${API_BASE_URL}/command-center/field-units/cameras/${cameraId}`,
  VOICE_COMMAND: (commandText) =>
    `${API_BASE_URL}/command-center/audio-listener/alerts/?command=${encodeURIComponent(commandText)}`,
  ALERT_DETAILS: (alertId) => `${API_BASE_URL}/command-center/cc-alerts/alerts/${alertId}/`,
  DEVICE_LIST: `${API_BASE_URL}/command-center/field-units/devices`,
  DEVICE_DETAIL: (deviceId) => `${API_BASE_URL}/command-center/field-units/device/${deviceId}`,
  DEVICE_ORDER: `${DEVICE_API_BASE_URL}/device_order`,
  DEVICE_CONFIG_PUT:(deviceId)=> `${API_BASE_URL}/command-center/device-config/settings/${deviceId}/`,
  DEVICE_CONFIG_POST : `${API_BASE_URL}/command-center/device-config/settings/`, 
  DEVICE_CONFIG : (deviceId)=> `${API_BASE_URL}/command-center/device-config/settings/${deviceId}/device/`, 
  LOGIN: `${API_BASE_URL}/command-center/user-auth/login/`,
  REFRESH_TOKEN: `${API_BASE_URL}/command-center/user-auth/token/refresh/`,
  ASSET_SESSION: `${API_BASE_URL}/command-center/user-auth/asset-session/`,
  AUTH_LIST: `${API_BASE_URL}/command-center/user-auth/auth/`,
  AUTH_LIST_UPDATE:(Id)=> `${API_BASE_URL}/command-center/user-auth/auth/${Id}/`,
  TENANTS: `${API_BASE_URL}/command-center/user-auth/tenants/`,
  TENANT_DETAIL: (id) => `${API_BASE_URL}/command-center/user-auth/tenants/${id}/`,
  USER_ROLES: `${API_BASE_URL}/command-center/user-auth/role/`,

  ROLE_LIST: `${API_BASE_URL}/command-center/user-auth/role/`,
  ALERT_LIST: `${API_BASE_URL}/command-center/cc-alerts/alerts/`,
  ACTIVE_ALERTS: `${API_BASE_URL}/command-center/cc-alerts/alerts/active-alerts/`,
  CAMERA_STREAM: (cameraId) =>
  `${API_BASE_URL}/command-center/cc-alerts/camera/${cameraId}/stream/?annotate=False`,
  DRONE_RETURN_TO_LAUNCH: (droneId) => `${API_BASE_URL}/command-center/field-units/drones/${droneId}/return_to_launch/`,
  DRONE_EMERGENCY_LAND: (droneId) => `${API_BASE_URL}/command-center/field-units/drones/${droneId}/emergency_land/`,
  DRONE_INJECT_APPROVAL: (droneId) => `${API_BASE_URL}/command-center/field-units/drones/${droneId}/inject_approval/`,
  FOREIGN_OBJECT_DETECTION: `${API_BASE_URL}/command-center/cc-alerts/foreign-object-detection/`,
  DRONES_ACTIVE: `${API_BASE_URL}/command-center/field-units/drones/active/`,
  PATHS: `${API_BASE_URL}/command-center/cc-alerts/paths/`,
  DRONE_PATHS: (droneId) => `${API_BASE_URL}/command-center/cc-alerts/paths/?drone=${droneId}`,
  WAYPOINTS: `${API_BASE_URL}/command-center/cc-alerts/waypoints/`,
  WAYPOINT_DETAIL: (id) => `${API_BASE_URL}/command-center/cc-alerts/waypoints/${id}/`,
  DRONE_WAYPOINTS: (droneId) => `${API_BASE_URL}/command-center/cc-alerts/waypoints/?drone=${droneId}`,
  CAMERA_PATHS: (cameraId) => `${API_BASE_URL}/command-center/cc-alerts/paths/?camera=${cameraId}`,
  CAMERA_WAYPOINTS: (cameraId) => `${API_BASE_URL}/command-center/cc-alerts/waypoints/?camera=${cameraId}`,
  FOREIGN_OBJECT_ALERTS: (droneId) => `${API_BASE_URL}/command-center/cc-alerts/foreign-object-alerts/?drone=${encodeURIComponent(droneId)}`,
  DRONE_RUNWAY_ALERTS: `${API_BASE_URL}/command-center/cc-alerts/foreign-object-alerts/`,
  DRONE_WHEP_STREAM: (droneId) => `${API_BASE_URL}/command-center/cc-alerts/drone/${droneId}/whep-stream/`,
  SENSOR_ALERTS: `${API_BASE_URL}/command-center/cc-alerts/sensor-alerts/`,
  ALERT_UPDATE: (alertId) => `${API_BASE_URL}/command-center/cc-alerts/alerts/${alertId}/update/`,
  SENSOR_ALERT_DETAILS: (sensorAlertId) =>`${API_BASE_URL}/command-center/cc-alerts/sensor-alerts/${sensorAlertId}/`,
  DISPATCH_ACTION: () => `${API_BASE_URL}/command-center/dispatch/`,
  SURVEY_PLANS: `${API_BASE_URL}/command-center/survey/plans/`,
  SURVEY_PLAN_DETAIL: (planId) => `${API_BASE_URL}/command-center/survey/plans/${planId}/`,
  SURVEY_PLAN_GENERATE: (planId) => `${API_BASE_URL}/command-center/survey/plans/${planId}/generate/`,
  SURVEY_PLAN_UPLOAD: (planId) => `${API_BASE_URL}/command-center/survey/plans/${planId}/upload/`,
  SURVEY_PLAN_IMPORT: `${API_BASE_URL}/command-center/survey/plans/import/`,
  SURVEY_PLAN_EXPORT: (planId) => `${API_BASE_URL}/command-center/survey/plans/${planId}/export/`,
  ALERT_CLOSE: (alertId) => `${API_BASE_URL}/command-center/cc-alerts/alerts/${alertId}/close/`,
  SENSOR_ALERT_CLOSE: (sensorAlertId) => `${API_BASE_URL}/command-center/cc-alerts/sensor-alerts/${sensorAlertId}/close/`,
  /**
   * PRD-09: project-scoped chat. Optional REACT_APP_CHAT_API_URL may be a host or
   * legacy `/api/chat` URL — both are normalized to construction project chat paths.
   */
  CHAT: (projectId) => {
    if (projectId == null || projectId === '') return null;
    const override = process.env.REACT_APP_CHAT_API_URL;
    let root = API_BASE_URL;
    if (override && override !== 'undefined') {
      root = override.replace(/\/api\/chat\/?$/, '').replace(/\/$/, '');
    }
    return `${root}/api/construction/projects/${encodeURIComponent(projectId)}/chat`;
  },
};
